<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      sx12
      sm4
      md4
    >
      <v-text-field
        v-model="registrationNumber"
        label="Гос номер машины"
        hide-details
        outline
        height="44"
        class="my-2 ml-2"
        :disabled="disabled"
        @change="change"
      />
    </v-flex>
    <v-flex
      sx12
      sm4
      md4
    >
      <EditDriver
        v-model="driver"
        :disabled="disabled"
        @change="changeDriver"
      />
    </v-flex>
    <v-flex
      sx12
      sm4
      md4
    >
      <v-text-field
        v-model="phone"
        label="Телефон водителя"
        mask="+##(###)###-##-##"
        hide-details
        outline
        height="44"
        class="my-2 ml-2"
        :disabled="disabled"
        @change="change"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import EditDriver from "./EditDriver.vue";
export default {
  components: {
    EditDriver,
  },
  props: ["value", "isNeedTransport", "disabled"],
  data() {
    return {
      registrationNumber: null,
      driver: null,
      phone: null,
    };
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.registrationNumber = this.value.registrationNumber;
          this.driver = this.value.driver;
          this.phone = this.value.phone;
        } else {
          this.registrationNumber = null;
          this.driver = null;
          this.phone = null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    change() {
      this.$emit("change", {
        registrationNumber: this.registrationNumber,
        driver: this.driver,
        phone: this.phone,
      });
    },
    changeDriver(value) {
      this.$emit("change", {
        registrationNumber: this.registrationNumber,
        driver: value,
        phone: this.phone,
      });
    },
  },
};
</script>
